import { connectionData, endpoint } from "./apiConnection.js";
export const dataProfesores = async () => connectionData(endpoint,'profesores','GET');
export const addProfesor = async (alumno_id,body) => connectionData(endpoint,'notas/'+alumno_id,'POST',body);